module.exports = "/images/exclamation-triangle.svg?7246c8d6653df472ac48b551d6fc4e38";